import {Button, Card, Col, Form, Input, message, Modal, Row, Select, Spin, Upload} from "antd";
import React, {useEffect, useState} from "react";
import {invest_template_img, invest_title_img} from '../../../AppImageConst';
import './style.scss'
import customerService from "../../service/customerService";
import ErrorHandler from "../../util/ErrorHandler";
import {CustomerDto} from "../../dto/CustomerDto";
import transactionFetchService from "../../service/transactionFetchService";
import {
    INVALID_AMOUNT,
    LIMIT_YOUR_INPUT,
    MSG_ALLOWED_ALL_DOCUMENT_TYPES_ERROR,
    MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR,
    MSG_FAILED_TO_FETCH_COLLECTION_BANK_LIST_ERROR,
    MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR,
    MSG_FAILED_TO_FETCH_FUND_LIST_ERROR,
    MSG_FAILED_TO_FETCH_PORTFOLIO_LIST_ERROR,
    MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR,
    MSG_INVEST_FAILURE,
    MSG_INVEST_SUCCESS,
    PLEASE_ENTER_AMOUNT
} from "../../util/Messages";
import {DropdownListDto} from "../../dto/DropdownListDto";
import {DefaultDocumentDto} from "../../dto/DefaultDocumentDto";
import Validation from "../../util/Validation";
import CommonFunction from "../../util/CommonFunction";
import {
    ALLOWED_ALL_TYPES_TEXT,
    ALLOWED_DOCUMENT_TYPE_EXTENSION,
    ALLOWED_DOCUMENT_TYPES,
    ALLOWED_IMAGE_TYPE_EXTENSION,
    ALLOWED_IMAGE_TYPES,
    AMOUNT_VALIDATION,
    DIGITS_AND_DOT_VALIDATION,
    DOCUMENT_TYPES,
    PREVIEW_DOC_TYPES,
    TRANSACTION_SUMMARY_PAGE_TYPES
} from "../../util/Constants";
import {DownloadOutlined, ExclamationCircleOutlined, HistoryOutlined, PlusOutlined} from "@ant-design/icons";
import documentService from "../../service/documentService";
import {UploadedDocumentDetailDto} from "../../dto/UploadedDocumentDetailDto";
import {toNumber} from "lodash";
import modal from "antd/es/modal";
import {TransactionTemplateDto} from "../../dto/TransactionTemplateDto";
import transactionService from "../../service/transactionService";
import {TransactionSummaryDto} from "../../dto/TransactionSummaryDto";
import PreviewModalComp from "../../components/common/preview/PreviewModalComp";
import TransactionSummaryPage from "./transactionSummaryPage";
import {getLoggedUserCinNumber, getTokenPrased} from "../../security/KeyclockConfig";

const InvestTemplatePage = () => {
    const uploadFileSize: number | undefined = process.env.UPLOAD_FILE_SIZE ? toNumber(process.env.UPLOAD_FILE_SIZE) : 4;

    const [portfolioList, setPortfolioList] = useState<DropdownListDto[]>([]);
    const [fundList, setFundList] = useState<DropdownListDto[]>([]);
    const [collectionBankList, setCollectionBankList] = useState<DropdownListDto[]>([]);
    const [isSpinning, setSpinning] = useState<boolean>(false);
    const [fundTransferReceiptList, setFundTransferReceiptList] = useState<DefaultDocumentDto[]>()
    const [jobNumber, setJobNumber] = useState<number>(0)
    const [uploadDocumentDetailId, setUploadDocumentDetailId] = useState<number>()
    const [form] = Form.useForm();
    const [isCanHideSummery, setCanHideSummery] = useState<boolean>(true);
    const [summaryData, setSummaryData] = useState<TransactionSummaryDto>({} as TransactionSummaryDto);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [docURL, setDocURL] = useState('');
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>(PREVIEW_DOC_TYPES.IMAGE);
    const [previewTitle, setPreviewTitle] = useState('');

    useEffect(() => {
        setSpinning(true)
        getLoggedUserCIN()
    }, [])

    const configs = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        accept: ".pdf, .jpeg, .jpg, .png"
    };
    const getLoggedUserCIN = () => {
        let cinNumber = getLoggedUserCinNumber();
        console.log("getTokenPrased" ,getTokenPrased());
        if (undefined != cinNumber) {
            fetchPortfolioList(cinNumber)
            fetchCustomerDetailsByCIN(cinNumber)
        } else {
            customerService.getCustomerCINByLoggedUser().then(res => {
                let cinNumber = res.data.results;
                fetchPortfolioList(cinNumber)
                fetchCustomerDetailsByCIN(cinNumber)
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinning(false)
            })
        }

    }

    const fetchCustomerDetailsByCIN = (cinNumber: string) => {
        customerService.getExactCustomerByCin(cinNumber).then(res => {
            if (res.data.results.customerMstDto != null) {
                const customerDto = res.data.results.customerMstDto as CustomerDto
                setJobNumber(customerDto.id as number)
            }

        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    const fetchFundList = () => {
        setSpinning(true)
        transactionFetchService.getAllFundList().then(res => {
            if (res.data !== null) {
                setFundList(res.data.results)
                setSpinning(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_FUND_LIST_ERROR).then();
                setSpinning(false)
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setSpinning(false)
        })
    }
    const fetchCollectionBankList = () => {
        setSpinning(true)
        transactionFetchService.getCollectionBankList().then(res => {
            if (res.data !== null) {
                setCollectionBankList(res.data.results)
                setSpinning(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_COLLECTION_BANK_LIST_ERROR).then();
                setSpinning(false)
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setSpinning(false)
        })
    }

    const fetchPortfolioList = (cinNumber: string) => {
        if (null != cinNumber) {
            setSpinning(true)
            transactionFetchService.getPortfolioListByCIN(cinNumber).then(res => {
                if (res.data !== null) {
                    setPortfolioList(res.data.results)
                    fetchFundList()
                    fetchCollectionBankList()
                    setSpinning(false)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_PORTFOLIO_LIST_ERROR).then();
                    setSpinning(false)
                }

            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinning(false)
            })
        } else {
            console.error("Unable to find cin number.");
        }
    }

    const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const value = event.target.value;
        const name = 'fundAmount';
        if (AMOUNT_VALIDATION.test(value)) {
            formatAndSetAmount(value, name)
        } else if (DIGITS_AND_DOT_VALIDATION.test(value)) {
            formatAndSetAmount(value, name)

        }
    };

    const formatAndSetAmount = (value: string, name: string) => {
        CommonFunction.toFixedMethod(name, value, form);
        form.validateFields([name]);
    }
    const handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (AMOUNT_VALIDATION.test(value)) {
            const name = 'fundAmount';
            let amount = CommonFunction.removeThousandSeparators(value);
            amount = amount.replace('.00', "")
            form.setFieldsValue({[name]: amount});
            form.validateFields([name]);
        }
    };


    const beforeUploadDocument = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.ITD, ALLOWED_DOCUMENT_TYPES.concat(ALLOWED_IMAGE_TYPES));
    };

    const validateDocument = (file: any, type: number, allowedDocTypes: string[]) => {
        setSpinning(true)
        let indexOf = allowedDocTypes.indexOf(file.type);
        if (indexOf < 0) {

            message.error(MSG_ALLOWED_ALL_DOCUMENT_TYPES_ERROR);
            setSpinning(false)
            return Upload.LIST_IGNORE;
        }
        const isLt2M = file.size / 1024 / 1024 <= uploadFileSize;
        if (!isLt2M) {
            message.error(`Document must smaller than ${uploadFileSize}MB!`);
            setSpinning(false)
            return Upload.LIST_IGNORE;
        }

        const formData = new FormData();
        formData.append("files", file);

        formData.append("jobNo", JSON.stringify(jobNumber));
        formData.append("documentTypeId", JSON.stringify(type));

        documentService.uploadDocument(formData).then(res => {
            if (res.data !== null) {
                let results = res.data.results;
                let uploadDocumentDetailDto: UploadedDocumentDetailDto = results.uploadDocumentDetailDtoList[0];
                createUploadedDocuments(uploadDocumentDetailDto, uploadDocumentDetailDto.documentTypeId, false)
                setUploadDocumentDetailId(uploadDocumentDetailDto.uploadDocumentDetailId)
                setSpinning(false)
            } else {
                setSpinning(false)
                message.error(MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR).then();
            }
        }, (reason) => {
            setSpinning(false)
            ErrorHandler.handleError(reason);
        })
        return false;
    };

    const createUploadedDocuments = (uploadDocumentDetailDtoList: UploadedDocumentDetailDto, documentTypeId: number, init: boolean) => {
        let defaultFileList;
        if (undefined != uploadDocumentDetailDtoList) {
            defaultFileList =
                [{
                    uid: uploadDocumentDetailDtoList.uploadDocumentDetailId.toString(),
                    name: uploadDocumentDetailDtoList.originalDocumentName,
                    thumbUrl: uploadDocumentDetailDtoList.thumbB64,
                    url: uploadDocumentDetailDtoList.thumbDocumentPath
                }]
        } else {
            defaultFileList = undefined;
        }

        if (documentTypeId == DOCUMENT_TYPES.ITD) {
            setFundTransferReceiptList(defaultFileList)
            form.setFieldsValue({documentUpload: defaultFileList})

        }
    };

    const onRemove = () => {
        setSpinning(true)
        if (fundTransferReceiptList) {
            documentService.deleteDocumentById(fundTransferReceiptList[0].uid).then(res => {
                if (res.data !== null) {
                    setFundTransferReceiptList([])
                    setUploadDocumentDetailId(undefined)
                    form.setFieldsValue({documentUpload: undefined})
                    setSpinning(false)
                } else {
                    message.error(MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR).then();
                    setSpinning(false)
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinning(false)
            })
        }

        return true;
    };

    const onSubmit = (values: any) => {

        modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure?, Do you want to invest money?`,
            okText: 'Yes',
            cancelText: 'No',
            className: 'confirm-dialog-box',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                setSpinning(true)
                let transactionTemplateDto: TransactionTemplateDto = {};
                transactionTemplateDto.portfolioId = values.portfolioId
                transactionTemplateDto.fundId = values.fundId
                transactionTemplateDto.fundAmount = toNumber(CommonFunction.removeThousandSeparators(values.fundAmount))
                transactionTemplateDto.transactionRefNo = values.transactionRefNo
                transactionTemplateDto.collectionAccountId = values.collectionAccountId
                transactionTemplateDto.transactionDocumentId = uploadDocumentDetailId

                transactionService.saveInvestMoney(transactionTemplateDto).then((res) => {
                    if (res.data.results) {
                        message.success(MSG_INVEST_SUCCESS)
                        setSpinning(false)
                        setFundTransferReceiptList([])
                        form.resetFields()
                        setUploadDocumentDetailId(undefined)
                        setSummaryDataToState(res.data.results.transactionTemplateDto)
                        setCanHideSummery(false)
                    } else {
                        message.error(MSG_INVEST_FAILURE)
                        setSpinning(false)
                    }
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                    setSpinning(false)

                })
            },
            onCancel() {

            }
        });
    }

    const setSummaryDataToState = (data: TransactionTemplateDto) => {
        let transactionData: TransactionSummaryDto = {
            portfolio: data.portfolioNumber,
            fund: data.fundName,
            transactionRefNo: data.transactionRefNo,
            investAmount: CommonFunction.currencyFormat(data.fundAmount),
            jobNumber: jobNumber,
            documentId: data.transactionDocumentId as number,
            refNumber: data.autoGeneratedRefNo,
            processingDate: data.processDate,
            collectionAccount: data.collectionAccountName,
        };

        setSummaryData(transactionData)
    }

    const onClose = () => {
        form.resetFields();
        setCanHideSummery(true)
    }

    const validateAmountLength = (_: any, value: any) => {
        if (!value) {
            return Promise.reject(PLEASE_ENTER_AMOUNT);
        }else if (validateAmountGreaterThanZero(value)){
            return Promise.reject(INVALID_AMOUNT);
        } else if (CommonFunction.removeThousandSeparators(value).length > 18) {
            return Promise.reject(LIMIT_YOUR_INPUT);
        } else if (!AMOUNT_VALIDATION.test(value)) {
            return Promise.reject(INVALID_AMOUNT);

        } else {
            return Promise.resolve();
        }
    };
    const validateAmountGreaterThanZero = (value: string | null) => {
      if (null != value){
          return (+ value) <= 0
      }
      return true;
    }
    const navigateHistory = () => {
        window.open("/workflow/customer/transaction-history/" + "invest-transactions", "_blank")
    }

    const onPreview = (documentId: string, docTypeName: string) => {
        setSpinning(true)
        documentService.viewOriginalDocument(documentId).then(res => {
            if (res.data !== null) {
                setPreviewOpen(true)
                setPreviewTitle(docTypeName);
                setDocURL(res.data.results)
                setDocType(CommonFunction.checkDocumentContentType(res.data.results))
                setSpinning(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                setSpinning(false)
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setSpinning(false)
        })
        return true;
    };

    const handlePreviewCancel = () => {
        setPreviewOpen(false);
    };


    return (
        <Row gutter={[40, 0]} className={'right-side-container-margin disabled-data-show-inputs-container'}>
            <Col lg={10} md={10} sm={0}
                 className={'left-side-main-container left-side-main-container-inside-dashboard'}>
                <Row>
                    <Col span={24}>
                        <div className="clip-path-img">
                            <div className='clip-path-img-container'>
                                <img src={invest_template_img} alt="logo"/>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Col>
            {isCanHideSummery ?

                <Col lg={14} md={14} sm={24}
                     className='right-side-main-container-inside-dashboard align-div-center layout-bottom-space dashboard-right-side-contaner-scroll'>
                    <Form
                        className='form-input'
                        layout={"vertical"}
                        form={form}
                        onFinish={onSubmit}
                    >
                        <div className='account_type_container second-applicant-details' style={{paddingTop: 16}}>
                            <div>
                                <Row gutter={[32, 0]}>
                                    <Col xs={24} sm={24} md={18} lg={18} xl={18} className='page-header-main-title-col'>
                                        <h2 className='page-header-main-title'
                                            style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                            <div className='header_icon header-icon-center'>
                                                <img style={{height: 24, width: 24}}
                                                     src={invest_title_img} alt=""/>
                                            </div>
                                            Invest Money
                                        </h2>
                                    </Col>
                                    <Col xs={8} sm={8} md={6} lg={6} xl={6} className='view-tr-history-btn-col'>
                                        <Button size={'small'} className={'view-tr-history-btn'} icon={<HistoryOutlined />} onClick={navigateHistory}
                                                >View History</Button>

                                    </Col>
                                </Row>
                                <Spin size="large" tip="Loading" spinning={isSpinning}>
                                    <Card className={'template_card'}>
                                        <Row gutter={[32, 0]}>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                <Form.Item
                                                    label="Portfolio ID"
                                                    name={"portfolioId"}
                                                    rules={
                                                        [{required: true, message: 'Please select portfolio'}]}>
                                                    <Select placement='bottomLeft' listHeight={180} size={'large'}
                                                            placeholder={"Select portfolio"}
                                                            getPopupContainer={(trigger: {
                                                                parentNode: any;
                                                            }) => trigger.parentNode}
                                                            style={{width: '100%'}}
                                                            options={portfolioList}
                                                    >
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                <Form.Item
                                                    label="Fund"
                                                    name={"fundId"}
                                                    rules={
                                                        [{required: true, message: 'Please select fund'}]}>
                                                    <Select placement='bottomLeft' listHeight={180} size={'large'}
                                                            placeholder={"Select fund"}
                                                            getPopupContainer={(trigger: {
                                                                parentNode: any;
                                                            }) => trigger.parentNode}
                                                            style={{width: '100%'}}
                                                            options={fundList}
                                                    >
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                <Form.Item
                                                    label={<><span className='custom-astrix'>*</span> Amount</>}
                                                    name={'fundAmount'}
                                                    rules={[{validator: validateAmountLength}]}>
                                                    <Input
                                                        onKeyPress={Validation.isNumber}
                                                        // maxLength={15}
                                                        type="text"
                                                        size={'large'}
                                                        onBlur={handleBlur}
                                                        onFocus={handleFocus}
                                                        autoComplete="off"
                                                        placeholder={"Enter amount"}/>
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                <Form.Item
                                                    label="Collection Account"
                                                    name={'collectionAccountId'}
                                                    rules={
                                                        [{
                                                            required: true,
                                                            message: 'Please select collection account'
                                                        }]}>
                                                    <Select placement='bottomLeft' listHeight={180} size={'large'}
                                                            placeholder={"Select collection account"}
                                                            getPopupContainer={(trigger: {
                                                                parentNode: any;
                                                            }) => trigger.parentNode}
                                                            style={{width: '100%'}}
                                                            options={collectionBankList}
                                                    >
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                <Form.Item
                                                    label="Transaction Reference Number"
                                                    name={'transactionRefNo'}
                                                    rules={
                                                        [{
                                                            required: true,
                                                            message: 'Please enter transaction reference number'
                                                        }]}>
                                                    <Input size={'large'}
                                                           placeholder={"Enter transaction reference number"}/>
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                <Form.Item
                                                    label="Upload Fund Transfer Receipt"
                                                    name={'documentUpload'}
                                                    rules={
                                                        [{
                                                            required: true,
                                                            message: 'Please upload fund transfer receipt'
                                                        }]}>
                                                    <Upload {...configs}
                                                            className='upload_comp'
                                                            accept={ALLOWED_IMAGE_TYPE_EXTENSION.concat(", " + ALLOWED_DOCUMENT_TYPE_EXTENSION)}
                                                            listType="picture"
                                                            onPreview={(e: any) => {
                                                                onPreview(fundTransferReceiptList ? fundTransferReceiptList[0].uid : '',
                                                                    fundTransferReceiptList ? fundTransferReceiptList[0].name : '')
                                                            }}
                                                            onRemove={onRemove}
                                                            fileList={fundTransferReceiptList && fundTransferReceiptList?.length > 0 ? fundTransferReceiptList : undefined}
                                                            beforeUpload={beforeUploadDocument}
                                                    >
                                                        {(undefined != fundTransferReceiptList ? fundTransferReceiptList.length : [].length) < 1 &&
                                                            <Button>
                                                                <div className='upload-btn-div'>
                                                                    <div className="upload-icon-div">
                                                                        <PlusOutlined
                                                                            style={{
                                                                                fontSize: 20,
                                                                                color: '#757575'
                                                                            }}/>
                                                                    </div>
                                                                    <div className="upload-btn-text-div">
                                                                <span>
                                                                    Fund Transfer Receipt {ALLOWED_ALL_TYPES_TEXT}
                                                                </span>
                                                                    </div>
                                                                </div>
                                                            </Button>
                                                        }
                                                    </Upload>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Spin>

                            </div>
                            <div>
                                <Row gutter={[32, 0]}>

                                    <Col sm={24} lg={{span: 8, offset: 16}} className='continue-btn-col text-right'>
                                        <Form.Item className='form-item-btn'>
                                            {/*Redirect to the summary page*/}
                                            <Button htmlType="submit" type="primary"
                                                    disabled={isSpinning}
                                                    className='custom-btn-primary ant-btn margin_top_20'>
                                                Submit
                                            </Button>
                                        </Form.Item>
                                    </Col>

                                </Row>
                            </div>
                        </div>
                    </Form>
                    <Modal
                        className={docType == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : "image-view-modal"}
                        open={previewOpen}
                        centered
                        title={previewTitle}
                        onCancel={handlePreviewCancel}
                        destroyOnClose={true}
                        width={docType == PREVIEW_DOC_TYPES.PDF ? 800 : 600}
                        footer={[
                            <Button type="primary" icon={<DownloadOutlined/>}
                                    style={{background: '#FF7400', height: 40}}
                                    htmlType="submit" onClick={() => CommonFunction.download(docURL, previewTitle)}>
                                Download
                            </Button>]}>
                        <PreviewModalComp docURL={docURL}/>
                    </Modal>
                </Col> : <TransactionSummaryPage summaryData={summaryData} onClose={onClose}
                                                 summaryPageType={TRANSACTION_SUMMARY_PAGE_TYPES.INVEST}/>}
        </Row>
    )

}
export default InvestTemplatePage;

